import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import { IFolderFilesRes } from './index.type';

const useSubFolderFiles = ({ folderId }: { folderId?: string }) => {
  const [subFolderFilesData, setSubFolderFilesData] = React.useState<IFolderFilesRes>();

  const { loading: subFolderFilesDataLoading, makeApiCall } = useApi({
    url: `/fileExchange?folder=${folderId}`,
    method: 'GET',
  });

  const getSubFolderFilesData = async () => {
    const { response, error } = await makeApiCall<undefined, IFolderFilesRes>();
    if (response?.status === 'success') {
      setSubFolderFilesData(response);
    }

    if (response?.status === 'fail') {
      setSubFolderFilesData(undefined);
    }

    if (error) toast.error(error.msg || 'Unable to load files. Please refresh and try again.');
  };

  return {
    subFolderFilesData,
    getSubFolderFilesData,
    subFolderFilesDataLoading,
  };
};

export default useSubFolderFiles;
